import { STOCK_TYPES } from "@/lib/api";

export const StockTypeSelect = ({ value, onChange, testId }) => (
  <label className="block">
    <span className="text-sm font-semibold text-slate-700">Stock type (optional)</span>
    <select value={value || ""} onChange={(e) => onChange(e.target.value)} className="fm-input mt-1" data-testid={testId}>
      <option value="">Not specified</option>
      {STOCK_TYPES.map((s) => <option key={s.value} value={s.value}>{s.label}</option>)}
    </select>
    <span className="block text-xs text-slate-500 mt-1">Shown to customers to explain why the price is lower.</span>
  </label>
);
